import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Table } from "antd";
import axios from "axios";

export class Alunos extends Component {
    state = {
        lista: [],
        listaMobile: [],
        //TABELA
        loading_table: false,
        //REDIRECT
        redirect: false,
        redirectLink: ""
    };

    //CHAMADA ANTES DO RENDER
    UNSAFE_componentWillMount() {
        this.listar();
    }

    componentDidUpdate() {
        if (this.props.atualizar) {
            this.listar();
            this.props.paraAtualizar();
        }
    }

    listar = () => {
        this.setState(
            {
                loading_table: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/gestao-estatistica/alunos-list",
                    params: {
                        dtini: this.props.dt_inicio.format("YYYY/MM/DD"),
                        dtfim: this.props.dt_termino.format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        var lista = [];
                        var listaMobile = [];

                        response.data.map((dado, index) => {
                            lista.push({
                                key: index,
                                ano: dado.ano,
                                mes: dado.mes,
                                ativos: dado.total
                            });
                            listaMobile.push({
                                key: index,
                                ano: `${dado.mes}/${dado.ano}`,
                                ativos: dado.total
                            });
                        });

                        this.setState({
                            lista,
                            listaMobile,
                            loading_table: false
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 401)
                            this.setState({
                                redirect: true,
                                redirectLink: "/login"
                            });
                    });
            }
        );
    };

    render() {
        const {
            lista,
            listaMobile,
            //TABELA
            loading_table,
            //REDIRECT
            redirect,
            redirectLink
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        const columns = [
            {
                title: "Ano",
                dataIndex: "ano",
                key: "ano"
            },
            {
                title: "Mês",
                dataIndex: "mes",
                key: "mes"
            },
            {
                title: "Novas",
                dataIndex: "ativos",
                key: "ativos"
            }
        ];

        const columnsMobile = [
            {
                title: "Mês/Ano",
                dataIndex: "ano",
                key: "ano"
            },
            {
                title: "Novas",
                dataIndex: "ativos",
                key: "ativos"
            }
        ];

        return (
            <>
                <Table
                    columns={columns}
                    className="tabela-estatisticas-desktop"
                    dataSource={lista}
                    pagination={false}
                    locale={{ emptyText: "Não existem registos!" }}
                    loading={{
                        spinning: loading_table,
                        indicator: (
                            <div className="loading-data-table">
                                <div className="loading" />
                            </div>
                        )
                    }}
                />
                <Table
                    columns={columnsMobile}
                    className="tabela-estatisticas-mobile"
                    dataSource={listaMobile}
                    pagination={false}
                    locale={{ emptyText: "Não existem registos!" }}
                    loading={{
                        spinning: loading_table,
                        indicator: (
                            <div className="loading-data-table">
                                <div className="loading" />
                            </div>
                        )
                    }}
                />
            </>
        );
    }
}

export default Alunos;
